import Select from '@material-ui/core/Select'
import styled from 'styled-components'

const DropDownStyled = styled(Select)`
  && {
    border: 1px solid #ccc;
    border-radius: 4px;
    height: 35px;
    &:before,
    &:after {
      border-bottom: none !important;
    }
    & > div > div {
      padding: 8px 20px 8px 10px;
      color: #4a4a4a;
      font-size: 14px;
    }
  }
`

export default DropDownStyled
